export function ajax(route, payload = {}, options){
    if( !route ) return;

    let data = {
        action: 'ff_custom_ajax',
        nonce: site_data.nonce,
        route,
    }

    jQuery.ajax({
        url: site_data.ajax_url,
        type: "post",
        data: {...data, ...payload},
        dataType : "json",
    })
    .done(function(res){
        if( typeof options.done === 'function' ) {
            options.done(res);
        }
    })
    .always(function(res){
        if( typeof options.always === 'function' ) {
            options.always(res);
        }
    })
}

export function ajax_fetch(action, callback = null, payload = null){

    const data = new FormData();
    data.append('action', action);
    
    if( payload && typeof payload === 'object' ) {
        Object.keys(payload).forEach(key=>{
            let value = payload[key];
            if( typeof value === 'object' ) {
                value = JSON.stringify(value);
            }
            data.append(key, value);
        }) 
    }
    
    fetch(site_data.ajax_url, {
        method: "POST",
        credentials: 'same-origin',
        body: data
    })
    .then((response) => response.json())
    .then((data) => {
        if( typeof callback === 'function' ) {
            callback(data);
        }
    })
    .catch((error) => {
        alert(error);
    });
}